const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.addStore.hideModal()
  }
}

export default OnEscape
